"use client";

import { Grid } from "@mui/material";
import { useRouter } from "next/navigation";
import { MetricCard } from "@/ui";
import { DASHBOARD_FOCUS } from "@lib/enums";
import getDashboardFocusConfig from "@lib/dashboard/dashboardFocus";

export default function BoxRow({ stats, focus = DASHBOARD_FOCUS.FLOATS }) {
  const router = useRouter();
  const changeRoute = (route) => router.push(`/${route}`);
  const config = getDashboardFocusConfig(focus);

  // The demo prompt only applies to floats — there is no demo submission.
  const createdLinkText = stats.only_demo_float
    ? "Customise demo float"
    : config.listLinkText;

  return (
    <Grid container spacing={3}>
      <Grid size={{ xs: 12, sm: 4 }} sx={{ display: "flex" }}>
        <MetricCard
          color="blue"
          title={config.createdLabel}
          value={stats.created}
          linkText={createdLinkText}
          onLinkClick={(e) => { e.preventDefault(); changeRoute(config.route); }}
          icon={<img src="/img/floats/ic-dash-created.svg" alt="" />}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }} sx={{ display: "flex" }}>
        <MetricCard
          color="pink"
          title={config.sentLabel}
          value={stats.sent}
          linkText={config.listLinkText}
          onLinkClick={(e) => { e.preventDefault(); changeRoute(config.route); }}
          icon={<img src="/img/floats/ic-dash-sent.svg" alt="" />}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }} sx={{ display: "flex" }}>
        <MetricCard
          color="orange"
          title={config.viewedLabel}
          value={stats.viewed}
          linkText={stats.viewed === 0 ? "No views yet!" : "Great work!"}
          icon={<img src="/img/floats/ic-dash-viewed.svg" alt="" />}
        />
      </Grid>
    </Grid>
  );
}
